const data = [
  {
    institute: [
      "IIT Bhilai",
      "IIT (BHU) Varanasi",
      "IIT Bhubaneswar",
      "IIT Bombay",
      "IIT Delhi",
      "IIT (ISM) Dhanbad",
      "IIT Dharwad",
      "IIT Gandhinagar",
      "IIT Goa",
      "IIT Guwahati",
      "IIT Hyderabad",
      "IIT Indore	",
      "IIT Jammu",
      "IIT Kanpur",
      "IIT Kharagpur",
      "IIT Madras",
      "IIT Mandi",
      "IIT Jodhpur",
      "IIT Palakkad",
      "IIT Patna",
      "IIT Roorkee",
      "IIT Ropar",
      "IIT Tirupati",
    ],
  },
  {
    "IIT Bhilai": [
      "Computer Science and Engineering",
      "Chemistry",
      "Electrical Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
    ],
    "IIT (BHU) Varanasi": [
      "Biochemical Engineering",
      "Biomedical Engineering",
      "Ceremic Engineering and Technology",
      "Chemical Engineering",
      "Chemistry",
      "Civil Enginnering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics Engineering",
      "Humanistic Studies",
      "Materials Science and Technology",
      "Mathematics Science",
      "Mechanical Engineering",
      "Metallurigical Engineering",
      "Mining Enginnering",
      "Pharmaceutical Engineering and Technology",
      "Physics",
    ],

    "IIT Bhubaneswar": [
      "Biosciences",
      "Chemistry",
      "Civil Enginnering (School of Infrastructure)",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics & Communication Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurigical & Materials Engineering",
      "Physics",
      "School of Earth, Ocean and Climate Sciences",
      "School of Humanities, Social Sciences & Management",
    ],

    "IIT Bombay": [
      "Aerospace Engineering",
      "Biosciences and Bioengineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science & Engineering",
      "Earth Sciences",
      "Electrical Engineering",
      "Energy Science and Engineering",
      "Environmental Science and Engineering",
      "Humanities & Social Sciences",
      "IDC School of Design (IDC SoD)",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical Engineering & Materials Science",
      "Physics",
      "Shailesh J. Mehta School of Management (SJMSoM)",
    ],

    "IIT Delhi": [
      "Applied Mechanics",
      "Biochemical Engineering and Biotechnology",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Design",
      "Electrical Engineering",
      "Energy Science and Engineering",
      "Humanities and Social Sciences",
      "Management Studies",
      "Materials Science and Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
      "Textile and Fibre Engineering",
    ],

    "IIT (ISM) Dhanbad": [
      "Applied Geology",
      "Applied Geophysics",
      "Chemical Engineering",
      "Chemistry and Chemical Biology",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics Engineering",
      "Environmental Science & Engineering",
      "Fuel, Minerals and Metallurgical Engineering",
      "Humanities and Social Sciences",
      "Management Studies",
      "Mathematics and Computing",
      "Mechanical Engineering",
      "Mining Engineering",
      "Petroleum Engineering",
      "Physics",
    ],
    "IIT Dharwad": [
      "Bioscience and Bioengineering",
      "Chemistry",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics",
      "Mechanical, Materials and Aerospace Engineering",
      "Physics",
    ],
    "IIT Gandhinagar": [
      "Biological Engineering",
      "Biomedical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Chemical Engineering",
      "Cognitive Science",
      "Computer Science and Engineering",
      "Earth Sciences",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Materials Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
    ],
    "IIT Goa": [
      "Chemical and Materials Engineering",
      "Chemistry",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics and Computing (MnC)/Mathematics",
      "Mechanical Engineering",
      "Physics Sciences",
      "School of Interdisciplinary Life Sciences (SILS)",
    ],
    "IIT Guawahati": [
      "Biosciences & Bioengineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Design",
      "Electronics & Electrical Engineering",
      "Humanities and Social Sciences",
      "Jyoti and Bhupat Mehta School of Health Science and Technology",
      "Mathematics",
      "Mechanical Engineering",
      "Mehta Family School of Data Science and Artificial Intelligence",
      "Physics",
      "School of Business",
      "School of Energy Science and Engineering",
    ],
    "IIT Hyderabad": [
      "Artificial Intelligence",
      "Biomedical Engineering",
      "Biotechnology",
      "Chemical Engineering",
      "Chemistry",
      "Climate Change",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Design",
      "Electrical Engineering",
      "Engineering Science",
      "Entrepreneurship and Management",
      "Heritage Science and Technology",
      "Liberal Arts",
      "Materials Science and Metallurgical Engineering",
      "Mathematics",
      "Mechanical & Aerospace Engineering",
      "Physics",
    ],
    "IIT Indore": [
      "Astronomy, Astrophysics and Space Engineering",
      "Biosciences and Biomedical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgy Engineering and Materials Science",
      "Physics",
    ],
    "IIT Jammu": [
      "Biosciences and Bioengineering",
      "Civil Engineering",
      "Chemistry",
      "Chemical Engineering",
      "Computer Science Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics",
      "Materials Engineering",
      "Mechanical Engineering",
      "Physics",
    ],
    "IIT Kanpur": [
      "Aerospace Engineering",
      "Biological Sciences & Bioengineering",
      "Chemistry",
      "Chemical Engineering",
      "Civil Engineering",
      "Computer Science & Engineering",
      "Design",
      "Earth Sciences",
      "Economic Sciences",
      "Electrical Engineering",
      "Humanities & Social Sciences",
      "Industrial & Management Engineering",
      "Materials Science & Engineering",
      "Mathematics & Statistics",
      "Mechanical Engineering",
      "Physics",
      "Sustainable Energy Engineering",
    ],
    "IIT Kharagpur": [
      "Agricultural and Food Engineering",
      "Bio Science",
      "Biotechnology",
      "Centre for Computational and Data Sciences",
      "Centre of Excellence in Advanced Manufacturing Technology",
      "Centre of Excellence in Artificial Intelligence (AI)",
      "Chemistry",
      "Chemical Engineering",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics and Electrical Communication Engineering",
      "Energy Science and Engineering",
      "Environmental Science and Engineering",
      "Geology and Geophysics",
      "Humanities and Social Sciences",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical and Materials Engineering",
      "Mining Engineering",
      "Ocean Engg and Naval Architecture",
      "Physics",
      "Rubber Technology",
      "Vinod Gupta School of Management",
    ],
    "IIT Madras": [
      "Aerospace Engineering",
      "Applied Mechanics",
      "Biotechnology",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Engineering Design",
      "Humanities and Social Sciences",
      "Management Studies",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical and Materials Engineering",
      "Ocean Engineering",
      "Physics",
    ],
    "IIT Mandi": [
      "Bio-Engineering",
      "Biotechnology",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Data Science and Engineering",
      "Electrical Engineering",
      "Engineering Physics",
      "Humanities and Social Sciences",
      "Materials Engineering ",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
    ],
    "IIT Jodhpur": [
      "Bioscience and Bioengineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil and Infrastructure Engineering",
      "Computer Science & Engineering",
      "Electrical Engineering",
      "Humanities & Social Sciences",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical & Materials Engineering",
      "Physics",
      "School of Management & Entrepreneurship",
      "School of Artificial Intelligence and Data Science",
    ],
    "IIT Palakkad": [
      "Biological Sciences and Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Data Science",
      "Electrical Engineering",
      "Environmental Sciences and Sustainable Engineering Center",
      "Humanities and Social Sciences",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
    ],
    "IIT Patna": [
      "Chemistry",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Mechanical Engineering",
      "Civil and Environmental Engineering",
      "Chemical and Biochemical Engineering",
      "Humanities and Social Sciences",
      "Mathematics",
      "Metallurgical and Materials Engineering",
      "Physics",
    ],
    "IIT Roorkee": [
      "Applied Mathematics and Scientific Computing",
      "Biosciences and Bioengineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Design",
      "Earthquake Engineering",
      "Earth Sciences",
      "Electrical Engineering",
      "Electronics and Communication Engineering",
      "Humanities and Social Sciences",
      "Hydrology",
      "Hydro and Renewable Energy",
      "Management Studies",
      "Mathematics",
      "Mechanical and Industrial Engineering",
      "Mehta Family School of Data Science and Artificial Intelligence",
      "Metallurgical and Materials Engineering",
      "Paper Technology",
      "Polymer and Process Engineering",
      "Physics",
      "Water Resources Development and Management",
    ],
    "IIT Ropar": [
      "BioMedical Engineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science & Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical and Materials Engineering",
      "Physics",
    ],
    "IIT Tirupati": [
      "Chemical Engineering",
      "Chemistry",
      "Civil & Environmental Engineering",
      "Computer Science & Engineering",
      "Electrical Engineering",
      "Humanities and Social Sciences",
      "Mathematics & Statistics",
      "Mechanical Engineering",
      "Physics",
    ],
  },
];

const data2 = [
  {
    "IIT Bhilai": [
      "Computer Science and Engineering",
      "Chemistry",
      "Electrical Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
    ],
  },
  {
    "IIT (BHU) Varanasi": [
      "Biochemical Engineering",
      "Biomedical Engineering",
      "Ceremic Engineering and Technology",
      "Chemical Engineering",
      "Chemistry",
      "Civil Enginnering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics Engineering",
      "Humanistic Studies",
      "Materials Science and Technology",
      "Mathematics Science",
      "Mechanical Engineering",
      "Metallurigical Engineering",
      "Mining Enginnering",
      "Pharmaceutical Engineering and Technology",
      "Physics",
    ],
  },
  {
    "IIT Bhubaneswar": [
      "Biosciences",
      "Chemistry",
      "Civil Enginnering (School of Infrastructure)",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics & Communication Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurigical & Materials Engineering",
      "Physics",
      "School of Earth, Ocean and Climate Sciences",
      "School of Humanities, Social Sciences & Management",
    ],
  },
  {
    "IIT Bombay": [
      "Aerospace Engineering",
      "Biosciences and Bioengineering",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science & Engineering",
      "Earth Sciences",
      "Electrical Engineering",
      "Energy Science and Engineering",
      "Environmental Science and Engineering",
      "Humanities & Social Sciences",
      "IDC School of Design (IDC SoD)",
      "Mathematics",
      "Mechanical Engineering",
      "Metallurgical Engineering & Materials Science",
      "Physics",
      "Shailesh J. Mehta School of Management (SJMSoM)",
    ],
  },
  {
    "IIT Delhi": [
      "Applied Mechanics",
      "Biochemical Engineering and Biotechnology",
      "Chemical Engineering",
      "Chemistry",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Design",
      "Electrical Engineering",
      "Energy Science and Engineering",
      "Humanities and Social Sciences",
      "Management Studies",
      "Materials Science and Engineering",
      "Mathematics",
      "Mechanical Engineering",
      "Physics",
      "Textile and Fibre Engineering",
    ],
  },
  {
    "IIT (ISM) Dhanbad": [
      "Applied Geology",
      "Applied Geophysics",
      "Chemical Engineering",
      "Chemistry and Chemical Biology",
      "Civil Engineering",
      "Computer Science and Engineering",
      "Electrical Engineering",
      "Electronics Engineering",
      "Environmental Science & Engineering",
      "Fuel, Minerals and Metallurgical Engineering",
      "Humanities and Social Sciences",
      "Management Studies",
      "Mathematics and Computing",
      "Mechanical Engineering",
      "Mining Engineering",
      "Petroleum Engineering",
      "Physics",
    ],
  },
];

const mnc = {
  companies: [
    "Wal-Mart Stores",
    "Exxon Mobil",
    "Chevron",
    "Berkshire Hathaway",
    "Apple",
    "Phillips 66",
    "General Motors",
    "Ford Motor",
    "General Electric",
    "Valero Energy",
    "AT&T",
    "CVS Caremark",
    "Fannie Mae",
    "UnitedHealth Group",
    "McKesson",
    "Verizon Communications",
    "Hewlett-Packard",
    "J.P. Morgan Chase & Co.",
    "Costco Wholesale",
    "Express Scripts Holding",
    "Bank of America",
    "Cardinal Health",
    "International Business Machines",
    "Kroger",
    "Marathon Petroleum",
    "Citigroup",
    "Archer Daniels Midland",
    "AmerisourceBergen",
    "Wells Fargo",
    "Boeing",
    "Procter & Gamble",
    "Freddie Mac",
    "Home Depot",
    "Microsoft",
    "Amazon.com",
    "Target",
    "Walgreen Co.",
    "WellPoint",
    "Johnson & Johnson",
    "American International Group",
    "State Farm Insurance Cos.",
    "MetLife",
    "PepsiCo",
    "Comcast",
    "United Technologies",
    "Google",
    "ConocoPhillips",
    "Dow Chemical",
    "Caterpillar",
    "United Parcel Service",
    "Pfizer",
    "Lowe’s Companies",
    "Intel Corporation",
    "Energy Transfer Equity, L.P.",
    "Cisco Systems, Inc.",
    "Enterprise Products Partners L.P.",
    "Aetna Inc.",
    "The Coca-Cola Company",
    "Lockheed Martin Corporation",
    "Best Buy Co., Inc.",
    "The Walt Disney Company",
    "CHS Inc.",
    "Sysco Corporation",
    "FedEx Corporation",
    "Merck & Co., Inc.",
    "INTL FCStone Inc.",
    "Safeway Inc.",
    "Johnson Controls, Inc.",
    "Ingram Micro Inc.",
    "Plains GP Holdings, L.P.",
    "World Fuel Services Corporation",
    "Prudential Financial, Inc.",
    "Humana Inc.",
    "The Goldman Sachs Group, Inc.",
    "Tesoro Corporation",
    "Liberty Mutual Holding Company Inc.",
    "Honeywell International Inc.",
    "United Continental Holdings, Inc.",
    "HCA Holdings, Inc.",
    "Deere & Company",
    "Delta Air Lines, Inc.",
    "Oracle Corporation",
    "Morgan Stanley",
    "Hess Corporation",
    "Twenty-First Century Fox, Inc.",
    "E.I. du Pont de Nemours and Company",
    "Sears Holdings Corporation",
    "New York Life Insurance Company",
    "Mondelez International, Inc.",
    "American Express Company",
    "Nationwide Mutual Insurance Co.",
    "The Allstate Corporation",
    "Tyson Foods, Inc.",
    "Supervalu Inc.",
    "TIAA-CREF",
    "Massachusetts Mutual Life Insurance Company",
    "CIGNA Corporation",
    "DIRECTV",
    "General Dynamics Corporation",
    "Philip Morris International Inc.",
    "3M Company",
    "Time Warner Inc.",
    "Halliburton Company",
    "Publix Super Markets, Inc.",
    "International Paper Company",
    "McDonald’s Corporation",
    "Macy’s, Inc.",
    "The TJX Companies, Inc.",
    "Fluor Corporation",
    "Northwestern Mutual Life Insurance Company,Inc.",
    "Tech Data Corporation",
    "American Airlines Group Inc.",
    "The Hartford Financial Services Group, Inc.",
    "The Travelers Companies, Inc.",
    "Nike, Inc.",
    "Occidental Petroleum Corporation",
    "Avnet, Inc.",
    "Rite Aid Corporation",
    "Exelon Corporation",
    "Qualcomm Incorporated",
    "Emerson Electric Co.",
    "Northrop Grumman Corporation",
    "Duke Energy Corporation",
    "Capital One Financial Corporation",
    "Aflac Incorporated",
    "Raytheon Company",
    "Staples, Inc.",
    "EMC Corporation",
    "Eli Lilly and Company",
    "Alcoa Inc.",
    "National Oilwell Varco, Inc.",
    "Baker Hughes Incorporated",
    "US Foods, Inc.",
    "Time Warner Cable Inc.",
    "Union Pacific Corporation",
    "Abbott Laboratories",
    "Xerox Corporation",
    "Arrow Electronics, Inc",
    "Kimberly-Clark Corporation",
    "U.S. Bancorp",
    "United Services Automobile Association",
    "Freeport-McMoRan Copper & Gold Inc.",
    "Icahn Enterprises L.P.",
    "ManpowerGroup Inc.",
    "HollyFrontier Corporation",
    "Global Partners LP",
    "The Goodyear Tire & Rubber Company",
    "PBF Energy Inc.",
    "Danaher Corporation",
    "Nucor Corporation",
    "Kohl’s Corporation",
    "AbbVie Inc.",
    "Whirlpool Corporation",
    "Amgen Inc.",
    "Jabil Circuit, Inc.",
    "Kraft Foods Group, Inc.",
    "The Progressive Corporation",
    "CenturyLink, Inc.",
    "General Mills, Inc.",
    "Southwest Airlines Co.",
    "Altria Group, Inc.",
    "AutoNation, Inc.",
    "Chesapeake Energy Corporation",
    "Dollar General Corporation",
    "TRW Automotive Holdings Corp.",
    "United States Steel Corporation",
    "Colgate-Palmolive Company",
    "Cummins Inc.",
    "PACCAR Inc",
    "The Southern Company",
    "Illinois Tool Works Inc.",
    "The PNC Financial Services Group, Inc.",
    "Medtronic, Inc.",
    "The AES Corporation",
    "Murphy USA Inc.",
    "Bristol-Myers Squibb Company",
    "Lear Corporation",
    "The Gap, Inc.",
    "Apache Corporation",
    "eBay Inc.",
    "The Bank of New York Mellon Corporation",
    "CBS Corporation",
    "PG&E Corporation",
    "ConAgra Foods, Inc.",
    "Computer Sciences Corporation",
    "American Electric Power Company, Inc.",
    "Western Digital Corporation",
    "Marathon Oil Corporation",
    "Baxter International Inc.",
    "PPG Industries, Inc.",
    "NextEra Energy, Inc.",
    "Community Health Systems, Inc.",
    "Loews Corporation",
    "Penske Automotive Group, Inc.",
    "FirstEnergy Corp.",
    "Starbucks Corporation",
    "Monsanto Company",
    "Kellogg Company",
    "Land O’Lakes, Inc.",
    "ONEOK, Inc.",
    "Omnicom Group Inc.",
    "Anadarko Petroleum Corporation",
    "EOG Resources, Inc.",
    "DISH Network Corporation",
    "Genuine Parts Company",
    "Kinder Morgan, Inc.",
    "Waste Management, Inc.",
    "The Chubb Corporation",
    "Aramark Holdings Corporation",
    "Viacom Inc.",
    "Las Vegas Sands Corp.",
    "Dominion Resources, Inc.",
    "Ecolab Inc.",
    "Smithfield Foods, Inc.",
    "Thermo Fisher Scientific Inc.",
    "Yum! Brands, Inc.",
    "Parker-Hannifin Corporation",
    "Whole Foods Market, Inc.",
    "Marriott International, Inc.",
    "C. H. Robinson Worldwide, Inc.",
    "L-3 Communications Holdings, Inc.",
    "Edison International",
    "Toys “R” Us, Inc.",
    "Nordstrom, Inc.",
    "Consolidated Edison, Inc.",
    "Marsh & McLennan Companies, Inc.",
    "Texas Instruments Incorporated",
    "Textron Inc.",
    "Tenet Healthcare Corporation",
    "DaVita HealthCare Partners Inc.",
    "CSX Corporation",
    "Lincoln National Corporation",
    "Praxair, Inc.",
    "PPL Corporation",
    "J.C. Penney Company, Inc.",
    "Peter Kiewit Sons’, Inc.",
    "Jacobs Engineering Group Inc.",
    "Visa Inc.",
    "H.J. Heinz Company",
    "CarMax, Inc.",
    "V.F. Corporation",
    "Entergy Corporation",
    "Automatic Data Processing, Inc.",
    "NRG Energy, Inc.",
    "Guardian Life Ins. Co. of America",
    "Liberty Interactive Corporation",
    "Norfolk Southern Corporation",
    "Office Depot, Inc.",
    "Ameriprise Financial, Inc.",
    "Gilead Sciences, Inc.",
    "Centene Corporation",
    "Leucadia National Corporation",
    "Huntsman Corporation",
    "Health Net, Inc.",
    "Stanley Black & Decker, Inc.",
    "URS Corporation",
    "Xcel Energy Inc.",
    "Bed Bath & Beyond Inc.",
    "Navistar International Corporation",
    "Synnex Corporation",
    "First Data Corporation",
    "AGCO Corporation",
    "L Brands, Inc.",
    "Hertz Global Holdings, Inc.",
    "CDW Corporation",
    "CST Brands, Inc.",
    "Sempra Energy",
    "R.R. Donnelley & Sons Company",
    "BB&T Corporation",
    "Devon Energy Corporation",
    "Family Dollar Stores, Inc.",
    "Unum Group",
    "Ally Financial Inc.",
    "Reinsurance Group of America, Incorporated",
    "State Street Corporation",
    "Air Products & Chemicals, Inc.",
    "Ross Stores, Inc.",
    "The Sherwin-Williams Company",
    "The Estée Lauder Companies Inc.",
    "BlackRock, Inc.",
    "Western Refining, Inc.",
    "Avon Products, Inc.",
    "The Mosaic Company",
    "Public Service Enterprise Group Incorporated",
    "Dean Foods Company",
    "Cameron International Corporation",
    "MGM Resorts International",
    "KKR & Co. L.P.",
    "Hilton Worldwide Holdings Inc.",
    "DTE Energy Company",
    "Genworth Financial, Inc.",
    "Henry Schein, Inc.",
    "Rock-Tenn Company",
    "WellCare Health Plans, Inc.",
    "W.W. Grainger, Inc.",
    "Discover Financial Services",
    "Eastman Chemical Company",
    "Principal Financial Group, Inc.",
    "Reliance Steel & Aluminum Co.",
    "AutoZone, Inc.",
    "Dover Corporation",
    "Micron Technology, Inc.",
    "Owens & Minor, Inc.",
    "Assurant, Inc.",
    "GameStop Corp.",
    "Stryker Corporation",
    "Group 1 Automotive, Inc.",
    "Cognizant Technology Solutions Corporation",
    "Sonic Automotive, Inc.",
    "Autoliv, Inc.",
    "Hormel Foods Corporation",
    "Motorola Solutions, Inc.",
    "Crown Holdings, Inc.",
    "SunTrust Banks, Inc.",
    "Campbell Soup Company",
    "Fidelity National Financial, Inc.",
    "HD Supply Holdings, Inc.",
    "Caesars Entertainment Corporation",
    "Darden Restaurants, Inc.",
    "Weyerhaeuser Company",
    "Ball Corporation",
    "Precision Castparts Corp.",
    "Masco Corporation",
    "Universal Health Services, Inc.",
    "Republic Services, Inc.",
    "MasterCard Incorporated",
    "Newmont Mining Corporation",
    "Broadcom Corporation",
    "Reynolds American Inc.",
    "PVH Corp.",
    "Charter Communications, Inc.",
    "AECOM Technology Corporation",
    "CenterPoint Energy, Inc.",
    "Pacific Life",
    "Thrivent Financial for Lutherans",
    "Becton, Dickinson and Company",
    "Franklin Resources, Inc.",
    "Tenneco Inc.",
    "TravelCenters of America LLC",
    "Avis Budget Group, Inc.",
    "Facebook, Inc.",
    "Dollar Tree, Inc.",
    "Corning Incorporated",
    "Ashland Inc.",
    "Sealed Air Corporation",
    "Core-Mark Holding Company, Inc.",
    "Oshkosh Corporation",
    "Coca-Cola Enterprises, Inc.",
    "WESCO International, Inc.",
    "Applied Materials, Inc.",
    "Visteon Corporation",
    "BorgWarner Inc.",
    "Spectrum Group International, Inc.",
    "Oaktree Capital Group, LLC",
    "Steel Dynamics, Inc.",
    "Jarden Corporation",
    "Mohawk Industries, Inc.",
    "Terex Corporation",
    "Northeast Utilities",
    "KBR, Inc.",
    "Fifth Third Bancorp",
    "UGI Corporation",
    "CBRE Group, Inc.",
    "Quest Diagnostics Incorporated",
    "Peabody Energy Corporation",
    "The Hershey Company",
    "Boston Scientific Corporation",
    "FMC Technologies, Inc.",
    "The Interpublic Group of Companies, Inc.",
    "Commercial Metals Company",
    "The Pantry, Inc.",
    "Owens-Illinois, Inc.",
    "American Family Ins. Group",
    "Ralph Lauren Corporation",
    "Biogen Idec Inc.",
    "PetSmart, Inc.",
    "Mylan Inc.",
    "Symantec Corporation",
    "Ameren Corporation",
    "The Williams Companies, Inc.",
    "Barnes & Noble, Inc.",
    "Huntington Ingalls Industries, Inc.",
    "The Priceline Group Inc.",
    "Agilent Technologies, Inc.",
    "Dana Holding Corporation",
    "Dillard’s, Inc.",
    "Seaboard Corporation",
    "Vanguard Health Systems, Inc.",
    "Casey’s General Stores, Inc.",
    "O’Reilly Automotive, Inc.",
    "The Blackstone Group L.P.",
    "Mutual of Omaha Insurance Company",
    "Molina Healthcare, Inc.",
    "CMS Energy Corporation",
    "Targa Resources Corp.",
    "Quanta Services, Inc.",
    "Cablevision Systems Corporation",
    "Avery Dennison Corporation",
    "Celanese Corporation",
    "Foot Locker, Inc.",
    "Celgene Corporation",
    "Advance Auto Parts, Inc.",
    "Mattel, Inc.",
    "Live Nation Entertainment, Inc.",
    "General Cable Corporation",
    "Ryder System, Inc.",
    "EMCOR Group, Inc.",
    "Allergan, Inc.",
    "W.R. Berkley Corporation",
    "Rockwell Automation, Inc.",
    "NetApp, Inc.",
    "Ingredion Incorporated",
    "Level 3 Communications, Inc.",
    "Calpine Corporation",
    "Omnicare, Inc.",
    "Erie Insurance Group",
    "SLM Corporation",
    "D.R. Horton, Inc.",
    "CC Media Holdings, Inc.",
    "Anixter International Inc.",
    "Dick’s Sporting Goods, Inc.",
    "SanDisk Corporation",
    "NCR Corporation",
    "Starwood Hotels & Resorts Worldwide, Inc.",
    "Expeditors International of Washington, Inc.",
    "Fidelity National Information Services, Inc.",
    "United Natural Foods, Inc.",
    "Auto-Owners Insurance Group",
    "Windstream Holdings, Inc.",
    "Dr Pepper Snapple Group, Inc.",
    "Lennar Corporation",
    "Sanmina",
    "Harley-Davidson, Inc.",
    "CONSOL Energy Inc.",
    "The J.M. Smucker Company",
    "Newell Rubbermaid Inc.",
    "CH2M HILL Companies, Ltd.",
    "Energy Future Holdings Corp.",
    "Susser Holdings Corporation",
    "Laboratory Corporation of America Holdings",
    "Kindred Healthcare, Inc.",
    "Leidos Holdings Inc.",
    "Booz Allen Hamilton Holding Corp.",
    "The Jones Financial Companies,L.L.L.P.",
    "Cliffs Natural Resources Inc.",
    "PulteGroup, Inc.",
    "Regions Financial Corporation",
    "NiSource Inc.",
    "Graybar Electric Company, Inc.",
    "Integrys Energy Group, Inc.",
    "The Clorox Company",
    "Wynn Resorts, Limited",
    "The Andersons, Inc.",
    "J.B. Hunt Transport Services, Inc.",
    "AK Steel Holding Corporation",
    "Harbinger Group Inc.",
    "MeadWestvaco Corporation",
    "The Western Union Company",
    "The Charles Schwab Corporation",
    "Discovery Communications, Inc.",
    "Spectra Energy Corp",
    "St. Jude Medical, Inc.",
    "CF Industries Holdings, Inc.",
    "Con-way Inc.",
    "Old Republic International Corporation",
    "JetBlue Airways Corporation",
    "Calumet Specialty Products Partners, L.P.",
    "Kelly Services, Inc.",
    "Domtar Corporation",
    "Murphy Oil Corporation",
    "Harris Corporation",
    "Asbury Automotive Group, Inc.",
    "Big Lots, Inc.",
    "Advanced Micro Devices, Inc.",
    "Owens Corning",
    "Realogy Holdings Corp.",
    "Host Hotels & Resorts, Inc.",
    "MRC Global Inc.",
    "Simon Property Group, Inc.",
    "Tractor Supply Company",
    "Gannett Co., Inc.",
    "Alaska Air Group, Inc.",
    "Insight Enterprises, Inc.",
    "McGraw Hill Financial, Inc.",
    "Buckeye Partners, L.P.",
    "Quintiles Transnational Holdings Inc.",
    "American Financial Group, Inc.",
    "United Stationers Inc.",
    "Coach, Inc.",
    "LKQ Corporation",
    "Noble Energy, Inc.",
    "Bemis Company, Inc.",
    "Joy Global Inc.",
    "Wyndham Worldwide Corporation",
    "NII Holdings, Inc.",
    "Lorillard, Inc.",
    "Alleghany Corporation",
    "Airgas, Inc.",
    "First American Financial Corporation",
    "United Rentals, Inc.",
  ],
};

export default data;
